// Saturation réglable des images couleur (HES…), appliquée par la carte graphique au moment de l'affichage :
// les tuiles ne sont ni retéléchargées ni redécodées quand le réglage change.
import { LayerExtension } from '@deck.gl/core';
import { BitmapLayer } from '@hms-dbmi/viv';

// 0 = niveaux de gris, 1 = couleurs d'origine, > 1 = couleurs renforcées.
const saturationModule = {
  name: 'hvSaturation',
  uniformTypes: { amount: 'f32' },
  fs: `
uniform hvSaturationUniforms {
  float amount;
} hvSaturation;
`,
  inject: {
    'fs:DECKGL_FILTER_COLOR': `
  float luma = dot(color.rgb, vec3(0.2126, 0.7152, 0.0722));
  color.rgb = clamp(mix(vec3(luma), color.rgb, hvSaturation.amount), 0.0, 1.0);
`,
  },
};

export class SaturationExtension extends LayerExtension {
  getShaders() {
    return { modules: [saturationModule] };
  }

  updateState(params, extension) {
    super.updateState(params, extension);
    const amount = this.props.saturation ?? 1;
    for (const model of this.getModels()) model.shaderInputs.setProps({ hvSaturation: { amount } });
  }
}
SaturationExtension.extensionName = 'SaturationExtension';

const saturationExtension = new SaturationExtension();

// renderSubLayers des tuiles couleur : même calque que Viv (BitmapLayer, mêmes limites de tuile), plus la saturation.
// photometric : interprétation des pixels du fichier (6 = YCbCr, JPEG d'un OME-TIFF lu directement : converti par le
// shader de Viv) ; RGB par défaut (tuiles du serveur).
export function renderRgbTile(props) {
  const { bbox: { left, top }, index: { x, y, z } } = props.tile;
  const { data, id, saturation, photometric } = props;
  if ([left, top].some(v => v < 0) || !data || !data.width || !data.height) return null;
  const scale = 2 ** Math.round(-z);
  const bounds = [left, top + data.height * scale, left + data.width * scale, top];
  return new BitmapLayer(props, {
    image: data,
    photometricInterpretation: photometric ?? 2,
    bounds,
    id: `tile-sub-layer-${bounds}-${id}`,
    tileId: { x, y, z },
    saturation,
    extensions: [saturationExtension],
  });
}
